<template lang="pug">
.logo(:style='{ alignItems: { start: "flex-start" }[align] }')
  img(:src='src' :style='style' alt='樂台計畫')
</template>

<script>
export default {
  name: 'Logo',
  props: {
    size: {
      type: Number,
      default: 170,
    },
    light: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    panel: {
      type: Boolean,
      default: false,
    },
    align: {
      type: String,
      default: 'center',
    },
  },
  data () {
    return {}
  },
  computed: {
    style () {
      return { maxWidth: `${this.size}px` }
    },
    src () {
      if (!this.light) {
        return this.small
          ? require('@/assets/img/logo/logo_secondary-small-white.svg')
          : this.panel
            ? require('@/assets/img/logo/logo_panel-white.svg')
            : require('@/assets/img/logo/logo_secondary-white.svg')
      } else {
        return this.small
          ? require('@/assets/img/logo/logo_secondary-small-black.svg')
          : this.panel
            ? require('@/assets/img/logo/logo_panel-black.svg')
            : require('@/assets/img/logo/logo_secondary-black.svg')
      }
    },
  },
}
</script>

<style scoped lang="sass">
.logo
  width: 100%
  height: auto
  +flex-center
  flex-direction: column
</style>
